export enum AssessmentLevelContent {
  Baixo,
  Medio,
  Alto,
}
